import { Component, OnInit } from '@angular/core';
import { GolfEventService } from '../../services/golf-event.service';
import { GolfEvent } from '../../models/GolfEvent';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CreateEventComponent } from './create-event/create-event.component';
import { EditEventComponent } from '../league/edit-event/edit-event.component';
import { PERMISSIONS, EVENT_FORMAT } from '../../models/constants';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-golf-event-list',
  standalone: true,
  imports: [NgFor, NgIf, CreateEventComponent, EditEventComponent],
  templateUrl: './golf-event-list.component.html',
  styleUrl: './golf-event-list.component.css'
})
export class GolfEventListComponent implements OnInit {
constructor(private golfEventService:GolfEventService, private router:Router, private authenticationService:AuthenticationService, private applicationService:ApplicationService) {}

  eventList:Array<GolfEvent> = [];
  canAddEvent:boolean = false;
  visibleComponent:string = "LIST"
  eventToEdit:GolfEvent|null = null;

  ngOnInit(): void {
    this.setupPermissions();
    this.getGolfEvents();
  }

  async setupPermissions():Promise<void> {
    this.canAddEvent = await this.authenticationService.hasPermission(PERMISSIONS.EVENTADMIN);
  }

  async getGolfEvents() {
    this.applicationService.showGlobalSpinner()
    this.eventList = await this.golfEventService.searchEvents();
    this.applicationService.hideGlobalSpinner();
  }

  switchVisibleComponent(component:string):void {
    this.visibleComponent = component;
  }

  editEvent(event:GolfEvent):void {
    this.eventToEdit = event;
    this.visibleComponent = 'EDIT';
  }

  async refreshEventList() {
    this.eventToEdit = null;
    this.switchVisibleComponent('LIST');
    await this.getGolfEvents();
  }

  navigateToEvent(event:GolfEvent):void {
    const playableTypes:Array<string> = [
      'LEAGUE',
      EVENT_FORMAT.SINGLE_COURSE,
      EVENT_FORMAT.MULTI_COURSE,
      EVENT_FORMAT.MULTI_WEEK_LEAGUE,
      EVENT_FORMAT.HYBRID_SCRAMBLE
    ];
    if(playableTypes.includes(event.type)) {
      this.router.navigate([`/league/${event.id}`]);
    }
  } 
}
